import { render, staticRenderFns } from "./QuotationPage.vue?vue&type=template&id=0fbb7144&scoped=true"
import script from "./QuotationPage.vue?vue&type=script&lang=js"
export * from "./QuotationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbb7144",
  null
  
)

export default component.exports